import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import SelectedCriteriaItem from "./SelectedCriteriaItem";
import palette from "../../styles/palette";
import { Label, MoreLabel } from "./Labels";

const useStyles = makeStyles(({ typography }) => ({
  root: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
  },
  labelValue: {
    color: palette.map.key2,
    paddingLeft: typography.pxToRem(5),
    textTransform: "capitalize",
    display: "inline-block",
  },
}));

const SelectedCriteria = ({
  selectedCriteria,
  onRemoveCriteria,
  onMoreClick,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {selectedCriteria
        .slice(0, 3)
        .map(({ criteria, operator, value, rule, id }) => (
          <SelectedCriteriaItem
            label={
              <Label
                criteria={criteria}
                operator={operator}
                value={value}
                rule={rule}
              />
            }
            id={id}
            handleDelete={() => onRemoveCriteria(id)}
          />
        ))}
      {selectedCriteria.length > 3 && (
        <SelectedCriteriaItem
          label={
            <span className={classes.labelValue}>{"selected criteria"}</span>
          }
          avatar={<MoreLabel criteriaCount={selectedCriteria?.length} />}
          handleClick={onMoreClick}
        />
      )}
    </div>
  );
};

export default SelectedCriteria;
